/**
 * @generated SignedSource<<d6861ca23bf594dc99275a43f9222773>>
 * @relayHash ad2ff8d257f5d00ff49e8ca190ac1c4c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/441.0.0-2023-12-05T07:13:15.252Z/PdpSharedShippingInfoQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type PdpSharedShippingInfoQuery$variables = {
  calculateLowerShippingInfo?: boolean | null;
  fetchItem?: boolean | null;
  fetchRegionalInfo?: boolean | null;
  fetchUser?: boolean | null;
  isClient?: boolean | null;
  isTrade?: boolean | null;
  itemId: string;
  itemQuantity?: number | null;
  shippingRegions?: ReadonlyArray<string | null> | null;
  userCountryCode?: string | null;
  userId: string;
  userZipCode?: string | null;
};
export type PdpSharedShippingInfoQuery$data = {
  readonly viewer: {
    readonly geography: {
      readonly countries: ReadonlyArray<{
        readonly abbreviation: string | null;
        readonly name: string | null;
      } | null> | null;
    } | null;
    readonly itemRead?: ReadonlyArray<{
      readonly serviceId?: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDutiesMessage_item" | "PdpSharedLowerShippingInfo_item" | "PdpSharedShippingInfoLink_item" | "PdpSharedShippingInfoWrapper_item" | "useShippingPrice_item" | "useShippingType_item">;
    } | null> | null;
    readonly regionSelectorEnabled: boolean | null;
    readonly relevantShipping: {
      readonly quoteRequestStatus: string | null;
      readonly shipment: {
        readonly shippingAddress: {
          readonly displayCityStateCountry: string | null;
        } | null;
      } | null;
      readonly shipmentQuote: {
        readonly buyerServiceMethodDisplay: string | null;
        readonly handlingTimeDisplay: string | null;
        readonly serviceMethod: {
          readonly serviceMethodType: string | null;
          readonly serviceType: string | null;
        } | null;
        readonly showQuoteAsPending: boolean | null;
        readonly subTotalAmount: {
          readonly convertedAmountList: ReadonlyArray<{
            readonly amount: number | null;
            readonly currency: Currency | null;
          } | null> | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDutiesMessage_shipmentQuote" | "PdpSharedShippingInfoLink_shipmentQuote">;
      } | null;
    } | null;
    readonly user?: {
      readonly addressBook: {
        readonly addressList: ReadonlyArray<{
          readonly displayCountry: string | null;
          readonly zipCode: string | null;
        } | null> | null;
        readonly personalAddress: {
          readonly displayCountry: string | null;
          readonly zipCode: string | null;
        } | null;
        readonly proAddress: {
          readonly displayCountry: string | null;
          readonly zipCode: string | null;
        } | null;
      } | null;
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPromoCode_user" | "PdpSharedShippingAddress_user" | "PdpSharedShippingInfoLink_user">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedLowerShippingInfo_viewer" | "PdpSharedPromoCode_viewer" | "PdpSharedShippingAddress_viewer" | "PdpSharedShippingHolidayDelivery_viewer" | "PdpSharedShippingInfoLink_viewer" | "useShippingPrice_viewer" | "useShippingType_viewer">;
  };
};
export type PdpSharedShippingInfoQuery = {
  response: PdpSharedShippingInfoQuery$data;
  variables: PdpSharedShippingInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "calculateLowerShippingInfo"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchItem"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchRegionalInfo"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isClient"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemQuantity"
},
v8 = {
  "defaultValue": ([]/*: any*/),
  "kind": "LocalArgument",
  "name": "shippingRegions"
},
v9 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v11 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v12 = {
  "alias": "regionSelectorEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "pdpRegionSelector"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"pdpRegionSelector\")"
},
v13 = {
  "kind": "Variable",
  "name": "fetchRegionalInfo",
  "variableName": "fetchRegionalInfo"
},
v14 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v15 = {
  "kind": "Variable",
  "name": "userZipCode",
  "variableName": "userZipCode"
},
v16 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "Geography",
  "kind": "LinkedField",
  "name": "geography",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GeographyObject",
      "kind": "LinkedField",
      "name": "countries",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "abbreviation",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v19 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v20 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v21 = {
  "kind": "Variable",
  "name": "quantity",
  "variableName": "itemQuantity"
},
v22 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode"
},
v23 = [
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v21/*: any*/),
  (v22/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quoteRequestStatus",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "displayShort",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "handlingTimeDisplay",
  "storageKey": "handlingTimeDisplay(displayShort:true)"
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v27 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "currency",
        "storageKey": null
      },
      (v26/*: any*/)
    ],
    "storageKey": null
  }
],
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "subTotalAmount",
  "plural": false,
  "selections": (v27/*: any*/),
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buyerServiceMethodDisplay",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showQuoteAsPending",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceType",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceMethodType",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayCityStateCountry",
  "storageKey": null
},
v34 = {
  "kind": "Variable",
  "name": "itemQuantity",
  "variableName": "itemQuantity"
},
v35 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v36 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "itemIds.0",
        "variableName": "itemId"
      }
    ],
    "kind": "ListValue",
    "name": "itemIds"
  }
],
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v38 = {
  "kind": "Literal",
  "name": "fetchShippingCostInfo",
  "value": true
},
v39 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v40 = {
  "kind": "Variable",
  "name": "shippingRegions",
  "variableName": "shippingRegions"
},
v41 = [
  (v35/*: any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayCountry",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zipCode",
  "storageKey": null
},
v44 = [
  (v42/*: any*/),
  (v43/*: any*/)
],
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v47 = [
  (v45/*: any*/),
  (v46/*: any*/)
],
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplimentary",
  "storageKey": null
},
v49 = [
  (v42/*: any*/),
  (v43/*: any*/),
  (v46/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "country",
    "storageKey": null
  }
],
v50 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "truncate",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "daysRelativeToExpiration",
  "storageKey": "daysRelativeToExpiration(truncate:false)"
},
v51 = {
  "condition": "fetchRegionalInfo",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "regionsInfo",
      "args": [
        (v19/*: any*/),
        (v22/*: any*/)
      ],
      "concreteType": "RegionalInfo",
      "kind": "LinkedField",
      "name": "regionalInfo",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RegionsByZipCode",
          "kind": "LinkedField",
          "name": "regionsByZipCode",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v46/*: any*/)
      ],
      "storageKey": null
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PdpSharedShippingInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingHolidayDelivery_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingInfoLink_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedPromoCode_viewer"
          },
          {
            "condition": "calculateLowerShippingInfo",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v16/*: any*/),
                "kind": "FragmentSpread",
                "name": "PdpSharedLowerShippingInfo_viewer"
              }
            ]
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingAddress_viewer"
          },
          (v17/*: any*/),
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": "RelevantShippingInfo",
            "kind": "LinkedField",
            "name": "relevantShipping",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "kind": "LinkedField",
                "name": "shipmentQuote",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedShippingInfoLink_shipmentQuote"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedDutiesMessage_shipmentQuote"
                  },
                  (v25/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentServiceMethod",
                    "kind": "LinkedField",
                    "name": "serviceMethod",
                    "plural": false,
                    "selections": [
                      (v31/*: any*/),
                      (v32/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Shipment",
                "kind": "LinkedField",
                "name": "shipment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "shippingAddress",
                    "plural": false,
                    "selections": [
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "args": (v16/*: any*/),
            "kind": "FragmentSpread",
            "name": "useShippingPrice_viewer"
          },
          {
            "args": [
              (v13/*: any*/),
              (v20/*: any*/),
              (v34/*: any*/),
              (v14/*: any*/),
              (v35/*: any*/),
              (v15/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "useShippingType_viewer"
          },
          {
            "condition": "fetchItem",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v36/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v37/*: any*/),
                      {
                        "args": [
                          (v18/*: any*/),
                          (v38/*: any*/),
                          (v34/*: any*/)
                        ],
                        "kind": "FragmentSpread",
                        "name": "useShippingPrice_item"
                      },
                      {
                        "condition": "calculateLowerShippingInfo",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": [
                              (v18/*: any*/),
                              (v38/*: any*/),
                              (v39/*: any*/),
                              (v34/*: any*/),
                              (v40/*: any*/),
                              (v14/*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "PdpSharedLowerShippingInfo_item"
                          }
                        ]
                      },
                      {
                        "args": [
                          (v34/*: any*/),
                          (v35/*: any*/)
                        ],
                        "kind": "FragmentSpread",
                        "name": "useShippingType_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedShippingInfoLink_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedShippingInfoWrapper_item"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PdpSharedDutiesMessage_item"
                      }
                    ],
                    "type": "Item",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v41/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v37/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AddressBook",
                    "kind": "LinkedField",
                    "name": "addressBook",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "proAddress",
                        "plural": false,
                        "selections": (v44/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "personalAddress",
                        "plural": false,
                        "selections": (v44/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "addressList",
                        "plural": true,
                        "selections": (v44/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedPromoCode_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedShippingInfoLink_user"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedShippingAddress_user"
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v6/*: any*/),
      (v10/*: any*/),
      (v2/*: any*/),
      (v11/*: any*/),
      (v9/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PdpSharedShippingInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "alias": null,
            "args": [
              (v20/*: any*/),
              (v35/*: any*/)
            ],
            "concreteType": "Promotion",
            "kind": "LinkedField",
            "name": "activePromotion",
            "plural": false,
            "selections": (v47/*: any*/),
            "storageKey": null
          },
          (v17/*: any*/),
          {
            "alias": null,
            "args": (v23/*: any*/),
            "concreteType": "RelevantShippingInfo",
            "kind": "LinkedField",
            "name": "relevantShipping",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "kind": "LinkedField",
                "name": "shipmentQuote",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  (v37/*: any*/),
                  (v25/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentServiceMethod",
                    "kind": "LinkedField",
                    "name": "serviceMethod",
                    "plural": false,
                    "selections": [
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v46/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v46/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Shipment",
                "kind": "LinkedField",
                "name": "shipment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "shippingAddress",
                    "plural": false,
                    "selections": [
                      (v33/*: any*/),
                      (v46/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v46/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "showShippingDiscounts",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "subsidizedShippingPDP"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"subsidizedShippingPDP\")"
          },
          (v46/*: any*/),
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "country",
                    "variableName": "userCountryCode"
                  },
                  (v20/*: any*/)
                ],
                "concreteType": "TransactionWarningQueryType",
                "kind": "LinkedField",
                "name": "transactionWarnings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasRestrictedMaterials",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCheckoutBlocked",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v23/*: any*/),
                "concreteType": "RelevantShippingInfo",
                "kind": "LinkedField",
                "name": "relevantShipping",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentQuote",
                    "kind": "LinkedField",
                    "name": "shipmentQuotes",
                    "plural": true,
                    "selections": [
                      (v37/*: any*/),
                      (v48/*: any*/),
                      (v29/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "kind": "LinkedField",
                        "name": "totalAmount",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShipmentServiceMethod",
                        "kind": "LinkedField",
                        "name": "serviceMethod",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          (v32/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Region",
                            "kind": "LinkedField",
                            "name": "region",
                            "plural": false,
                            "selections": (v47/*: any*/),
                            "storageKey": null
                          },
                          (v46/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v46/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v18/*: any*/),
                  (v20/*: any*/)
                ],
                "concreteType": "Conversation",
                "kind": "LinkedField",
                "name": "buyerItemConversation",
                "plural": false,
                "selections": [
                  (v37/*: any*/),
                  (v46/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v41/*: any*/),
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v37/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AddressBook",
                    "kind": "LinkedField",
                    "name": "addressBook",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "proAddress",
                        "plural": false,
                        "selections": (v49/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "personalAddress",
                        "plural": false,
                        "selections": (v49/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Address",
                        "kind": "LinkedField",
                        "name": "addressList",
                        "plural": true,
                        "selections": (v49/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "condition": "isTrade",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "daysToExpiration",
                            "value": 7
                          },
                          {
                            "kind": "Literal",
                            "name": "promoCodes",
                            "value": [
                              "TRADEWELCOME",
                              "TRADE1STWELCOME"
                            ]
                          }
                        ],
                        "concreteType": "Promotion",
                        "kind": "LinkedField",
                        "name": "expiringPromotion",
                        "plural": false,
                        "selections": [
                          (v50/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/)
                        ],
                        "storageKey": "expiringPromotion(daysToExpiration:7,promoCodes:[\"TRADEWELCOME\",\"TRADE1STWELCOME\"])"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmRewards",
                        "kind": "LinkedField",
                        "name": "tradeFirmRewards",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v41/*: any*/),
                            "concreteType": "currentPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "currentPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Promotion",
                                "kind": "LinkedField",
                                "name": "promotion",
                                "plural": false,
                                "selections": [
                                  (v45/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "buyerExpirationDate",
                                    "storageKey": null
                                  },
                                  (v46/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "expiringPromoSegmentType",
                            "kind": "LinkedField",
                            "name": "expiringPromoSegment",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "expiringSegmentCode",
                                "storageKey": null
                              },
                              (v50/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v41/*: any*/),
                                "concreteType": "currentPromoSegmentType",
                                "kind": "LinkedField",
                                "name": "currentPromoSegment",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "segmentCode",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v46/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "alias": "canRequestShippingQuotePermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "B_REQUEST_SHIPPING_QUOTE"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"B_REQUEST_SHIPPING_QUOTE\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v46/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "calculateLowerShippingInfo",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v51/*: any*/)
            ]
          },
          (v51/*: any*/),
          {
            "condition": "fetchItem",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": (v36/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "itemRead",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v37/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "vertical",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShipmentQuote",
                        "kind": "LinkedField",
                        "name": "shipmentQuotes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          (v48/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FinancialAmount",
                            "kind": "LinkedField",
                            "name": "totalAmount",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ConvertedAmounts",
                                "kind": "LinkedField",
                                "name": "convertedAmounts",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "USD",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ShipmentServiceMethod",
                            "kind": "LinkedField",
                            "name": "serviceMethod",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Region",
                                "kind": "LinkedField",
                                "name": "region",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "regionName",
                                    "storageKey": null
                                  },
                                  (v46/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v46/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v46/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          (v18/*: any*/),
                          (v21/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "useLiveEndpoint",
                            "value": true
                          }
                        ],
                        "concreteType": "RelevantShippingInfo",
                        "kind": "LinkedField",
                        "name": "relevantShippingInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ShipmentQuote",
                            "kind": "LinkedField",
                            "name": "shipmentQuote",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "kind": "LinkedField",
                                "name": "buyerTotalAmount",
                                "plural": false,
                                "selections": (v27/*: any*/),
                                "storageKey": null
                              },
                              (v46/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "priceType",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "buyerId",
                            "value": ""
                          },
                          {
                            "kind": "Literal",
                            "name": "isTrade",
                            "value": false
                          }
                        ],
                        "concreteType": "ItemDisplayPriceType",
                        "kind": "LinkedField",
                        "name": "displayPrice",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textType",
                            "storageKey": null
                          }
                        ],
                        "storageKey": "displayPrice(buyerId:\"\",isTrade:false)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasShipmentQuotes",
                        "storageKey": null
                      },
                      {
                        "alias": "itemIsOnHold",
                        "args": [
                          (v18/*: any*/)
                        ],
                        "kind": "ScalarField",
                        "name": "isOnHold",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPrivateListing",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemAttributes",
                        "kind": "LinkedField",
                        "name": "attributes",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AttributeValue",
                            "kind": "LinkedField",
                            "name": "leadTime",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "value",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAuctionEnabled",
                        "storageKey": null
                      },
                      {
                        "condition": "calculateLowerShippingInfo",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 0
                              },
                              (v40/*: any*/)
                            ],
                            "concreteType": "moreLikeThisConnection",
                            "kind": "LinkedField",
                            "name": "moreLikeThis",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalResults",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              (v18/*: any*/),
                              (v39/*: any*/),
                              (v14/*: any*/)
                            ],
                            "concreteType": "ItemDisplayPriceType",
                            "kind": "LinkedField",
                            "name": "displayPrice",
                            "plural": true,
                            "selections": (v27/*: any*/),
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "type": "Item",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v46/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/441.0.0-2023-12-05T07:13:15.252Z/PdpSharedShippingInfoQuery",
    "metadata": {},
    "name": "PdpSharedShippingInfoQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3e6d28313204d6b716d720d9f65670e6";

export default node;
